import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { PlasmicRootProvider } from '@plasmicapp/react-web';
import { HelmetProvider } from 'react-helmet-async';
import { CompetitionProvider } from './contexts/CompetitionContext';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Aggiungiamo un evento di installazione per la PWA
window.addEventListener('beforeinstallprompt', (e) => {
  // Memorizza l'evento per usarlo più tardi
  window.deferredPrompt = e;
  console.log('App è installabile!');
});

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <PlasmicRootProvider>
      <HelmetProvider>
        <BrowserRouter>
          <CompetitionProvider>
            <App />
          </CompetitionProvider>
        </BrowserRouter>
      </HelmetProvider>
    </PlasmicRootProvider>
  </React.StrictMode>
);

// Registriamo il service worker per la PWA
serviceWorkerRegistration.register({
  onUpdate: registration => {
    window.dispatchEvent(new Event('swUpdated'));
    window.swRegistration = registration;
  }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
